'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { GoArrowUpRight } from 'react-icons/go';
import { useCurrentStore } from '../../utils/use-store-utils';

interface CTABannerProps {
  title: string;
  description: string;
  button: {
    label: string;
    href: string;
  };
  background: {
    mobileUrl: string;
    desktopUrl: string;
  };
  className?: {
    section?: string;
    container?: string;
  };
}

export function CTABanner({ title, description, button, background, className }: CTABannerProps) {
  const { isGasGas, isCFMoto } = useCurrentStore();

  return (
    <section className={cn('custom-section', 'pt-[30px] sm:pt-0', className?.section)}>
      <div
        className={cn(
          'custom-container',
          'relative flex items-center justify-center md:justify-end lg:p-10 xl:p-12',
          className?.container,
        )}
      >
        <Image
          src={
            isCFMoto
              ? '/images/top-right-corner-blue.svg'
              : isGasGas
                ? '/images/top-right-corner-red.svg'
                : '/images/top-right-corner.svg'
          }
          alt=""
          width={48}
          height={48}
          className="absolute right-0 top-0 z-20 hidden md:block"
        />
        <div className="relative z-10 flex w-full flex-col items-center justify-center gap-4 p-6 pb-[180px] sm:gap-5 sm:p-8 sm:pb-[200px] md:max-w-[640px] md:items-start md:justify-start md:p-0 md:pb-0 lg:gap-6">
          <div className="flex flex-col items-center justify-center gap-2 sm:gap-3 md:items-start md:justify-start lg:gap-4">
            <h4 className="text-center text-[28px] font-medium tracking-tighter text-white sm:text-3xl md:text-left lg:text-4xl">
              {title}
            </h4>
            <p className="text-center text-sm text-white/70 sm:text-base md:text-left">
              {description}
            </p>
          </div>
          <Button asChild className={cn(isGasGas && '!text-white', isCFMoto && '!text-white')}>
            <Link prefetch={false} href={button.href} target="_blank">
              {button.label} <GoArrowUpRight size={18} />
            </Link>
          </Button>
        </div>
        <Image
          src={background.desktopUrl}
          alt="KTM Banner"
          width={0}
          height={0}
          className="absolute inset-0 z-0 hidden h-full w-full object-cover object-center md:block"
          sizes="auto, (min-width: 1288px) 1240px, calc(100vw - 48px)"
        />
        <Image
          src={background.mobileUrl}
          alt="KTM Banner"
          width={0}
          height={0}
          className="absolute inset-0 z-0 block h-full w-full object-cover object-center md:hidden"
          sizes="auto, (min-width: 1288px) 1240px, calc(100vw - 48px)"
        />
      </div>
    </section>
  );
}
